import { useBrandsAccessQuery } from "~/graphql/graphql-new.gen";

export const useBrandsAccess = () => {
  const brandsAccess = useBrandsAccessQuery(undefined, {
    select: (data) =>
      data.getBrandsAccess.filter((brandAccess) => !!brandAccess),
    staleTime: 1000,
  });

  return brandsAccess;
};
